module.exports = __webpack_public_path__ + "img/demo_landscaper-400x300.5fdb4ed2.jpg";